module.exports = __webpack_public_path__ + "media/video_bg_remove.338145ce.mp4";